'use client';

import { Button } from '@/components/ui/Button';
import { useEffect, useRef, useState } from 'react';

/**
 * V2.2d — Subscribe button stub. Opens a warmth-styled native <dialog> on
 * click instead of a browser alert(). V2.4 will wire this to Stripe checkout.
 */
export function SubscribeButton({ yuan }: { yuan: string }) {
  const [open, setOpen] = useState(false);
  const dialogRef = useRef<HTMLDialogElement | null>(null);

  useEffect(() => {
    const el = dialogRef.current;
    if (!el) return;
    if (open && !el.open) el.showModal();
    if (!open && el.open) el.close();
  }, [open]);

  return (
    <>
      <Button variant="primary" size="sm" onClick={() => setOpen(true)}>
        订阅 (即将上线)
      </Button>
      <dialog
        ref={dialogRef}
        onClose={() => setOpen(false)}
        aria-label="订阅即将上线"
        className="bg-transparent p-0 m-0 backdrop:bg-ink/40 max-w-md w-[calc(100%-2rem)]"
      >
        <div className="bg-cream rounded-2xl border border-soft p-6 shadow-lg">
          <h2 className="font-serif text-2xl text-ink mb-2">即将上线</h2>
          <p className="text-dusk text-sm leading-relaxed mb-4">
            订阅 <span className="text-ink font-medium">¥{yuan}/月</span> —
            完整对话、深度访谈、研报推送。我们正在 V2.4 接入支付流程，敬请期待。
          </p>
          <p className="text-dusk text-xs leading-relaxed mb-5">
            想要早期通知？发邮件给 hello@agentx.app，我们会第一时间联系你。
          </p>
          <div className="flex justify-end">
            <Button variant="ghost" size="sm" onClick={() => setOpen(false)}>
              关闭
            </Button>
          </div>
        </div>
      </dialog>
    </>
  );
}
